export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Reply-White-140bbe51e7bec1008f62e70bd72e4836.svg";